import { Analysis, ANALYSIS_TYPES } from '@core';
import { MappedAnalysisMetadata, SwingAnalysis } from '@data';

import { queryClient } from '../config/client';
import { queryKeys } from '../queryKeys';

const DEFAULT_METADATA: MappedAnalysisMetadata = { golfBallTranslation: [0, 0, 0] };

export const updateSwingAnalysis = (userId: string, uuid: string, type: ANALYSIS_TYPES, analysis: Analysis) => {
    const analysisKey = queryKeys.swings.analysis(userId, uuid);
    const cachedAnalysis = queryClient.getQueryData<SwingAnalysis>(analysisKey);

    const isQuickAnalysis = type === ANALYSIS_TYPES.QUICK_ANALYSIS;

    const newAnalysis: SwingAnalysis = isQuickAnalysis
        ? {
              quickAnalysis: analysis,
              fullAnalysis: cachedAnalysis?.fullAnalysis || null,
              metadata: cachedAnalysis?.metadata ?? DEFAULT_METADATA,
          }
        : {
              quickAnalysis: cachedAnalysis?.quickAnalysis || null,
              fullAnalysis: analysis,
              metadata: cachedAnalysis?.metadata ?? DEFAULT_METADATA,
          };

    queryClient.setQueryData<SwingAnalysis>(analysisKey, newAnalysis);
};
